import { ColumnsProps, columnType } from '../../TableList'
import { isModerator } from '../../../helpers/role-helper'

export const requestsColumns: ColumnsProps[] = [
  {
    columns: [
      {
        columnName: 'target.brand.avatar',
        columnType: columnType.IMAGE,
      },
    ],
    visible: true,
  },
  {
    name: 'Project name',
    columns: [
      {
        columnName: 'target.name',
        columnType: columnType.TEXT,
      },
    ],
    visible: true,
  },
  {
    name: 'Brand',
    columns: [
      {
        columnName: 'target.brand.name',
        columnType: columnType.TEXT,
      },
    ],
    visible: true,
  },
  {
    name: 'Assigned',
    columns: [
      {
        columnName: 'assignee.name',
        columnType: columnType.TEXT,
      },
      {
        columnName: 'assignee.avatar',
        columnType: columnType.IMAGE,
      },
    ],
    visible: true,
  },
  // Only moderator can see moderator column
  ...(isModerator()
    ? [
        {
          name: 'Moderator',
          columns: [
            {
              columnName: 'moderator.name',
              columnType: columnType.TEXT,
            },
            {
              columnName: 'moderator.avatar',
              columnType: columnType.IMAGE,
            },
          ],
          visible: true,
        },
      ]
    : []),
  {
    name: 'Request Type',
    columns: [
      {
        columnName: 'requestTicketType.requestType',
        columnType: columnType.TEXT,
      },
    ],
    visible: false,
  },
  {
    name: 'Request Type Title',
    columns: [
      {
        columnName: 'requestTicketType.title',
        columnType: columnType.TEXT,
      },
    ],
    visible: true,
  },
  {
    name: 'Status',
    columns: [
      {
        columnName: 'state',
        columnType: columnType.STATE,
      },
    ],
    visible: true,
  },
  {
    name: 'Urgency',
    columns: [
      {
        columnName: 'urgency',
        columnType: columnType.TEXT,
      },
    ],
    visible: false,
  },
  {
    name: 'Created',
    columns: [
      {
        columnName: 'requesterType',
        columnType: columnType.ICON,
      },
      {
        columnName: 'createdAt',
        columnType: columnType.DATE_AGO,
      },
    ],
    visible: true,
  },
  {
    name: 'Date scheduled',
    columns: [
      {
        columnName: 'scheduledFor',
        columnType: columnType.DATE,
      },
    ],
    visible: false,
    nullResult: '',
  },
]



// WEBPACK FOOTER //
// ./src/components/ProducerRequests/config/columns.ts